import { FunctionComponent, ReactElement } from "react";
import "./LoadingSpinner.css";

interface LoadingSpinnerProps {}

const LoadingSpinner: FunctionComponent<LoadingSpinnerProps> = (props: LoadingSpinnerProps): ReactElement => {
	return (
		<>
			<div id="hidder"></div>
			<div id="spinner">
				{" "}
				<span id="ball_1" className="spinner_ball"></span>
				<span id="orange-1" className="rectangle orange"></span>
				<span id="orange-2" className="rectangle orange"></span>
				<span id="blue-1" className="rectangle blue"></span>
				<span id="blue-2" className="rectangle blue"></span>
				<span id="light-blue-1" className="rectangle light-blue"></span>
				<span id="light-blue-2" className="rectangle light-blue"></span>
				<span id="gray-1" className="rectangle gray"></span>
				<span id="gray-2" className="rectangle gray"></span>
			</div>
		</>
	);
};

export default LoadingSpinner;
